import React from 'react';
import { createRoot } from 'react-dom/client';
import { Button, Modal } from 'react-bootstrap';

const ConfirmDialog = ({
  cancelLabel,
  confirmLabel,
  confirmStyle,
  message,
  onClose,
  title,
}) => (
  <Modal show onHide={() => onClose(false)}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{message}</Modal.Body>
    <Modal.Footer>
      <Button onClick={() => onClose(false)}>{cancelLabel}</Button>
      <Button bsStyle={confirmStyle} onClick={() => onClose(true)}>
        {confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);

const confirmDialog = (message, options = {}) => {
  if (typeof document === 'undefined') {
    return Promise.resolve(false);
  }

  return new Promise((resolve) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container);

    const cleanup = () => {
      root.unmount();
      container.remove();
    };

    const handleClose = (result) => {
      cleanup();
      resolve(result);
    };

    root.render(
      <ConfirmDialog
        cancelLabel={options.cancelLabel || 'Cancel'}
        confirmLabel={options.confirmLabel || 'Confirm'}
        confirmStyle={options.confirmStyle || 'primary'}
        message={message}
        onClose={handleClose}
        title={options.title || 'Confirm Action'}
      />
    );
  });
};

export default confirmDialog;
